var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckboxOutlineBlankSharp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19 6v12c0 .5-.5 1-1 1H6c-.5 0-1-.5-1-1V6c0-.5.5-1 1-1h12c.5 0 1 .5 1 1m-1-3H6C4.5 3 3 4.5 3 6v12c0 1.5 1.5 3 3 3h12c1.5 0 3-1.5 3-3V6c0-1.5-1.5-3-3-3"
})));
export default SvgCheckboxOutlineBlankSharp;